module.exports = __webpack_public_path__ + "static/media/clothes-2.9c2400f9.jpg";